import React from 'react';
import Swal from 'sweetalert2';

import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faCalendarAlt, faEdit, faFilter, faHashtag, faPlus, faSync, faTrashAlt } from '@fortawesome/free-solid-svg-icons';

class Listar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        anosComercializador: [],
        archivosComercializadores: []
    }
    cargarAnos() {
        Swal.showLoading();
        authAxios.get("archivos_comercializadores/anos_archivos")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, anosComercializador: datosRespuesta.data.data });
                Swal.close();
            })
            .catch(console.log);
    }
    ListarArchivosComercializadores(page) {
        Swal.showLoading();
        let anosComercializador = document.getElementById('anosComercializador').value;
        let nombreArchivoComercializador = document.getElementById('nombreArchivoComercializador').value;
        if (nombreArchivoComercializador == '') {
            nombreArchivoComercializador = 0;
        }
        if (anosComercializador == '') {
            anosComercializador = 0;
        }
        authAxios.get("archivos_comercializadores/cargar_archivos/" + nombreArchivoComercializador + "/" + anosComercializador + "?page=" + page)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                Swal.close();
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, load: '', archivosComercializadores: datosRespuesta.data.data, pagina: datosRespuesta.data.total, ultimo: datosRespuesta.data.last_page, actual: datosRespuesta.data.current_page });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarArchivosComercializadores(1);
    }
    render() {
        const { load, anosComercializador, archivosComercializadores, pagina, ultimo, actual } = this.state;
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            <Link className="btn btn-success btn-sm" to={"/AddCargueComercializador"}><FontAwesomeIcon icon={faPlus} />&nbsp;&nbsp;Nuevo Cargue</Link>
                        </div>
                        <div className="card-body">
                            <h4>Lista Archivos Cargados Comercializadoras</h4>
                            <hr />
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className='row g-3'>
                                        <div className="col-xl-2">
                                            <select name="anosComercializador" id="anosComercializador"
                                                className={"form-select form-select-sm"}
                                                onChange={this.cambioValor}>
                                                <option key="2023" value="2023">2023</option>
                                                <option key="2024" value="2024">2024</option>
                                            </select>
                                        </div>
                                        <div className="col-xl-4">
                                            <input style={{ textTransform: 'uppercase' }} type="text" id="nombreArchivoComercializador" name="nombreArchivoComercializador" placeholder="Archivo" className="form-control form-control-sm" />
                                        </div>
                                        <div className="col-xl-3">
                                            <button id="buttonFiltrarComercializador" name="buttonFiltrarComercializador" className="btn btn-secondary btn-sm" onClick={() => this.ListarArchivosComercializadores(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <table className="table table-hover table-condensed table-sm">
                                    <thead className="thead-inverse">
                                        <tr>
                                            <th className="align-middle">AÑO</th>
                                            <th className="align-middle">MES</th>
                                            <th className="align-middle">NOMBRE ARCHIVO</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            archivosComercializadores.map((itemArchivosComercializador) => (
                                                <tr key={itemArchivosComercializador.ID_TABLA}>
                                                    <td>{itemArchivosComercializador.ANO_FACTURA}</td>
                                                    <td>{itemArchivosComercializador.MES_FACTURA}</td>
                                                    <td>{itemArchivosComercializador.RUTA}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <nav aria-label="Page navigation example">
                                <ul className="pagination">
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArchivosComercializadores(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArchivosComercializadores(actual - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    {(() => {
                                        let p = [];
                                        p.push(<li className="page-item" key={actual}><a className="page-link" href="#" onClick={() => this.BuscarArrayResultado(actual)}>{actual}</a></li>);
                                        return p;
                                    })()}
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArchivosComercializadores(actual + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                    <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarArchivosComercializadores(ultimo)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                </ul>
                            </nav>
                        </div>
                        <div className="card-footer text-muted">
                            <b>Pagina</b> <span className="badge bg-primary">{actual}</span> <b>de</b> <span className="badge bg-primary">{ultimo}</span> | <b>Registros</b> <span className="badge bg-success">{pagina}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Listar;